<template>
  <div>
    <label v-if="label">{{ input.display_name }}</label>
    <component
      :form="form"
      :is="input.component.name"
      :label="label"
      :value="value"
      :input="input"
      :multiple="multiple"
    ></component>
  </div>
</template>

<script>
export default {
  name: "search-item",
  props: ["input", "type", "form", "label", "value", "multiple"],

  components: {
    icon: () => import(`../Ui/Search/null.vue`),
    id: () => import(`../Ui/Search/id.vue`),
    modal: () => import(`../Ui/Search/id.vue`),
    permissionModal: () => import(`../Ui/Search/id.vue`),
    lead_id: () => import(`../Ui/Search/id.vue`),
    date: () => import(`../Ui/Search/date`),
    string: () => import(`../Ui/Form/autocomplete`),
    clickShow: () => import(`../Ui/Form/string`),
    name: () => import(`../Ui/Form/string`),
    birthday: () => import(`../Ui/Search/birthday`),
    json: () => import(`../Ui/Form/string`),
    color: () => import(`../Ui/Search/null.vue`),
    textField: () => import(`../Ui/Form/string`),
    leadStatus: () => import(`../Ui/Form/leadStatus`),
    selectbox: () => import(`../Ui/Form/selectBox.vue`),
    status: () => import(`../Ui/Search/status`),
    integer: () => import(`../Ui/Form/integer`),
    double: () => import(`../Ui/Form/double`),
    email: () => import(`../Ui/Search/email`),
    password: () => import(`../Ui/Search/null`)
  }
};
</script>

<style></style>
